/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from '@emotion/react';
import { Box } from '@mui/material';
import { FC } from 'react';
import { QSTypography } from '../../../../../../../shared/components/atoms';
import { MessageTypes } from '../../../../typings/message-types';
import { formatTextSegmentIntoJSX } from '../../../../../../../shared/utils/text-transformer';
import ReactionPreview from './ReactionPreview';
import { getReactionPreview, getMaskedText } from '../utils';

const preprocessDisplayText = (text: string) => {
  let trimText = text?.trim();
  trimText = trimText.replace(/(\r\n|\n|\r)/gm, ' ');
  const formattedText = formatTextSegmentIntoJSX(trimText);
  return formattedText;
};

interface MessagePreviewContentProps {
  message: MessageTypes | undefined;
  messageOriginType: string | undefined;
  currentUserId: string | undefined;
  showUnreadUI: boolean;
  imgSrc?: string;
  icon?: JSX.Element;
  text: string;
  textStyle?: SerializedStyles;
  hasAccess: boolean;
  phoneNumber: string | undefined;
}

const MessagePreviewContent: FC<MessagePreviewContentProps> = ({
  message,
  messageOriginType,
  currentUserId,
  showUnreadUI,
  imgSrc,
  icon,
  text,
  textStyle,
  hasAccess,
  phoneNumber,
}) => {
  const reactionPreview = getReactionPreview({ message, messageOriginType, currentUserId });
  const shouldWrapInQuotes = !!reactionPreview && !!text && text.trim().length > 0;

  return (
    <Box
      css={css`
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex: 1;
      `}
    >
      {message && reactionPreview && <ReactionPreview reactionPreview={reactionPreview} />}
      <Box
        css={css`
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex: 1;
          overflow: hidden;
        `}
      >
        {shouldWrapInQuotes && (
          <span
            css={css`
              color: #616161;
              font-size: 14px;
              font-weight: 400;
            `}
          >
            "
          </span>
        )}
        {imgSrc && (
          <img
            src={imgSrc}
            loading="lazy"
            css={css`
              height: 18px;
            `}
            alt="placeholder"
          />
        )}
        {icon ? icon : null}
        {!!text && text?.trim()?.length > 0 && (
          <QSTypography
            css={css`
              font-size: 14px;
              font-weight: 400;
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: ${showUnreadUI ? 'rgba(40, 40, 40, 1)' : 'rgba(122, 122, 122, 1)'};
              margin-left: ${imgSrc || icon ? '4px' : '0px'};
              ${textStyle}
            `}
          >
            {preprocessDisplayText(hasAccess ? text : getMaskedText(phoneNumber, text))}
            {shouldWrapInQuotes && (
              <span
                css={css`
                  color: ${showUnreadUI ? 'rgba(40, 40, 40, 1)' : 'rgba(122, 122, 122, 1)'};
                  font-size: 14px;
                  font-weight: 400;
                `}
              >
                "
              </span>
            )}
          </QSTypography>
        )}
      </Box>
    </Box>
  );
};

export default MessagePreviewContent;
